// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ResponsiveModalHeaderButtons__buttons___30Klm","closeButton":"ResponsiveModalHeaderButtons__closeButton___3QBqK"};